/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_LiveInputs */

const th_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังแข่ง`)
};

const en_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const ja_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合中`)
};

const zh_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播`)
};

const es_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En directo`)
};

const pt_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao vivo`)
};

const id_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung`)
};

const fr_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En direct`)
};

const tl_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const vi_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trực tiếp`)
};

const ko_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실시간`)
};

const de_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const ru_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эфир`)
};

const tr_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı`)
};

const it_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diretta`)
};

const pl_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na żywo`)
};

const uk_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ефір`)
};

const hi_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव`)
};

const ar_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباشر`)
};

const ms_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung`)
};

const bn_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরাসরি`)
};

const zh_tw2_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播`)
};

const zh_hk2_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播`)
};

const ur_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`براہ راست`)
};

const fa_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زنده`)
};

const sw_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moja kwa moja`)
};

const nl_tab_live = /** @type {(inputs: Tab_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Tab_LiveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_live = /** @type {((inputs?: Tab_LiveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_LiveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_live(inputs)
	if (locale === "ja") return ja_tab_live(inputs)
	if (locale === "zh") return zh_tab_live(inputs)
	if (locale === "es") return es_tab_live(inputs)
	if (locale === "pt") return pt_tab_live(inputs)
	if (locale === "id") return id_tab_live(inputs)
	if (locale === "fr") return fr_tab_live(inputs)
	if (locale === "tl") return tl_tab_live(inputs)
	if (locale === "vi") return vi_tab_live(inputs)
	if (locale === "ko") return ko_tab_live(inputs)
	if (locale === "de") return de_tab_live(inputs)
	if (locale === "ru") return ru_tab_live(inputs)
	if (locale === "tr") return tr_tab_live(inputs)
	if (locale === "it") return it_tab_live(inputs)
	if (locale === "pl") return pl_tab_live(inputs)
	if (locale === "uk") return uk_tab_live(inputs)
	if (locale === "hi") return hi_tab_live(inputs)
	if (locale === "ar") return ar_tab_live(inputs)
	if (locale === "ms") return ms_tab_live(inputs)
	if (locale === "bn") return bn_tab_live(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_live(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_live(inputs)
	if (locale === "ur") return ur_tab_live(inputs)
	if (locale === "fa") return fa_tab_live(inputs)
	if (locale === "sw") return sw_tab_live(inputs)
	if (locale === "nl") return nl_tab_live(inputs)
	return en_tab_live(inputs)
});